import Logger from "../services/logger/Logger";

const DB_URL = "https://marty-serial-numbers-map-default-rtdb.firebaseio.com/";

const SHOW_LOGS = true;
const TAG = "MartySerialNumbersDBMap";

export const mapMartySnToRicSn = async (martySn: string): Promise<string> => {
    try {
        const res = await fetch(`${DB_URL}${martySn.replaceAll("-", "")}.json`);
        const data = await res.json();
        if (typeof data !== "string") {
            Logger.error(SHOW_LOGS, TAG, "Data fetched from DB is not a string: ", data);
            return "";
        }
        return data as string;
    } catch (error) {
        Logger.error(SHOW_LOGS, TAG, "Error fetching data from DB: " + error);
        return "";
    }
};